export class EmailConstants {
    public static maxAmount = 400;
}
